import {TelemetryGenericEnum} from '../../shared/enums';
import {analyticsConstants, constants} from '../../constants';
import {TrackHealthCenterExternalLinkInterface} from '../interfaces';

import {TrackingUtilsService} from './tracking-utils.service';
import {AnalyticsService} from '../../modules/core/services/analytics.services';
import {retrieveAnalyticsServiceValuesCase} from './retrieve-analytics-service-values.case';

export const trackHealthCenterExternalLinkPayloadCase = (
  payload: any,
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService
): TrackHealthCenterExternalLinkInterface | undefined => {
  const data = Object.assign({}, payload);
  if (!data.guestData) return undefined;

  const {analyticsData, language, brand, loyaltyNum, vdsId, platform} = retrieveAnalyticsServiceValuesCase(analyticsService, trackingUtilsService, data.guestData.loggedInPaxId);
  return {
    interaction: `${constants.INTERACTIONS.HEALTH_CENTER_EXTERNAL_LINK_CLICK}${data.linkText}`,
    currentPage: constants.PAGE_NAME_FOR_TRACKING.CHECK_IN_HEALTH_CENTER,
    brand: brand ?? TelemetryGenericEnum.EMPTY_VALUE,
    country: analyticsData?.country,
    language: language ?  language.toLowerCase() : analyticsConstants.DEFAULT_LANGUAGE,
    siteSection: analyticsData?.channel,
    consumerId: analyticsData?.paxid,
    loyaltyNum: loyaltyNum ?? TelemetryGenericEnum.EMPTY_VALUE,
    passengerId: data.guestData.loggedInPaxId ?? constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID,
    vdsId,
    bookingId: data.guestData.bookingId,
    platform: platform ?? TelemetryGenericEnum.EMPTY_VALUE,
    loginStatus : constants.LOGIN_STATUS.LOGGED_IN
  }
}
